import React, { useState, useCallback } from 'react'
import { Typography } from 'react-components'
import { useTranslation } from '../../../hooks/locale'
import { VirtualTourIcon, VirtualTourTagContainer, VirtualTourTextContainer } from './styles'
import { Image } from '../../property-details/expose-gallery/gallery/types'
import VirtualTourModal from './virtual-tour-modal'
import { VirtualTourPosition } from '../../property-details/constants'
import AnalyticsService from '../../../services/analytics-service'
import { commonPageEventActions } from '../../../services/analytics-service/actions'
import { pageTypeEventCategories } from '../../../services/analytics-service/categories'

interface Props {
    analyticsCategory:
        | typeof pageTypeEventCategories.PROPERTY_DETAILS_PAGE
        | typeof pageTypeEventCategories.SEARCH_RESULT_LISTING_PAGE
    analyticsLabel: VirtualTourPosition.PDP_GALLERY | VirtualTourPosition.OBJECT_CARD | VirtualTourPosition.GRID_CARD
    video?: Image
    handleCtaClick?: (e: React.MouseEvent) => void
    isSmallVersion?: boolean
}

const VirtualTourTag: React.FC<Props> = ({
    video,
    handleCtaClick,
    isSmallVersion = false,
    analyticsCategory,
    analyticsLabel,
}) => {
    const { t } = useTranslation()
    const [isOverlayOpen, setOverlay] = useState(false)

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            if (video) {
                e.stopPropagation()
                setOverlay(true)
                AnalyticsService.trackEvent({
                    category: analyticsCategory,
                    action: commonPageEventActions.virtualTourTag.VIRTUAL_TOUR_TAG_CLICKED,
                    label: analyticsLabel,
                })
            }
        },
        [video, analyticsCategory, analyticsLabel],
    )

    const handleClose = useCallback(() => {
        setOverlay(false)
    }, [])

    return (
        <>
            <VirtualTourTagContainer onClick={handleClick} $isSmall={isSmallVersion}>
                <VirtualTourIcon />
                <VirtualTourTextContainer>
                    <Typography variant={isSmallVersion ? 'overline' : 'caption'} fontWeight="regular" lineHeight={1}>
                        {t('gallery.virtual')}
                    </Typography>
                    <Typography variant={isSmallVersion ? 'caption' : 'subtitle2'} fontWeight="semiBold" lineHeight={1}>
                        {t('gallery.tour')}
                    </Typography>
                </VirtualTourTextContainer>
            </VirtualTourTagContainer>
            {isOverlayOpen && !!video && (
                <VirtualTourModal
                    isOpen={isOverlayOpen}
                    onClose={handleClose}
                    video={video}
                    handleCtaClick={handleCtaClick}
                />
            )}
        </>
    )
}

export default VirtualTourTag
